<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Cadastro - Código de Lançamento"
    [p-disclaimer-group]="disclaimerGroup" [p-actions]="pageActions" [p-filter]="filterSettings" p-subtitle="Consulte os dados cadastrados no sistema.">
    <p class="po-font-subtitle">Verifique todos os Código de Lançamento incluídos no sistema.
    </p>
    <po-divider></po-divider>
    <div class="po-row po-mb-4 shadow">
        <div>
            <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
        </div>
        <po-table #dynamicTable p-container="border" [p-actions]="actions" class="po-mr-1 po-ml-1 po-lg-12" #wppTable
            (p-show-more)="loadMore()"
            [p-show-more-disabled]="!moreItens" p-striped="true" p-text-wrap="true"
            [p-loading-show-more]="!isHideLoading"
            [p-spacing]="poTableColumnSpacing" p-container="border" p-hide-columns-manager="false"
            [p-columns]="columns" [p-items]="tableItens">
            <ng-template p-table-column-template [p-property]="'codigo'" let-value>
                <!-- <span [innerText]="value" class="po-font-text-large-bold"></span> -->
                <po-tag [p-value]="value" p-icon="an an-star" class="po-font-text-large-bold"> </po-tag>
            </ng-template>
        </po-table>
    </div>
</po-page-list>
